import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-service px-4 py-5 sm:py-7" data-id="element-74" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-3xl items-start gap-3" data-id="element-75" data-mp="1o3doggt1mlt9">
        <ShieldCheckIcon className="mt-0.5 hidden h-10 w-10 shrink-0 text-white sm:block" aria-hidden="true" data-id="element-76" data-mp="222d9lehckiko" />
        <div data-id="element-77" data-mp="1x28rxl4pdhsv">
          <h2 className="text-xl leading-tight text-white sm:text-2xl" data-id="element-78" data-mp="1x2igd4a3ngwg">
            Your purchase is 100% protected
          </h2>
          <p className="mt-1.5 text-sm font-medium leading-snug text-white/90 sm:text-base" data-id="element-79" data-mp="14gfln1k77l1c">
            Explore HVAC DIAGNOSTIC READY™ for 7 days.
          </p>
          <p className="mt-1 text-sm font-medium leading-snug text-white/90 sm:text-base" data-id="element-80" data-mp="1j6dh82kgjd0k">
            Review the six diagnostic modules, visual maps, troubleshooting flows, component
            references, field resources and four professional bonuses.
          </p>
          <p className="mt-1 text-sm font-medium leading-snug text-white/90 sm:text-base" data-id="element-81" data-mp="lon3k26o3k8e">
            If the system isn’t right for you, contact us within 7 days for a full refund
            according to the refund terms.
          </p>
        </div>
      </div>
    </section>;
}